import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CarouselComponent } from '../../../../modules/carousel/carousel.component';
import { CarouselTile } from '../../../../modules/carousel/carousel.model';



@Component({
  selector: 'app-ansprechpartner-carousel',
  imports: [
    CarouselComponent
  ],
  templateUrl: './ansprechpartner-carousel.component.html',
  styleUrls: ['./ansprechpartner-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnsprechpartnerCarouselComponent {

  public tiles: CarouselTile[] = [
    {
      img: {
        src: 'assets/img/pboot6.jpg',
        // width: 1120,
        // height: 742,
        alt: 'Hallo zum Regatta-Segeln im YSTM',
        // srcset: [
        //   'assets/img/xs/pboot6.webp 688w',
        //   'assets/img/sm/pboot6.webp 912w',
        //   'assets/img/md/pboot6.webp 1120w',
        //   'assets/img/lg/pboot6.webp 1360w',
        //   'assets/img/xl/pboot6.webp 2320w',
        // ],
        sizes: ['90vw'],
        priority: true,
      }
    },
    {
      img: {
        src: 'assets/img/spi1.jpg',
        // width: 1120,
        // height: 742,
        alt: 'Spinnaker-Segeln im YSTM',
        //style: 'width:100%;height:100%;object-fit:cover;object-position:50% 60%;',
        objectPosition: '50% 60%',
        // srcset: [
        //   'assets/img/xs/spi1.webp 688w',
        //   'assets/img/sm/spi1.webp 912w',
        //   'assets/img/md/spi1.webp 1120w',
        //   'assets/img/lg/spi1.webp 1360w',
        //   'assets/img/xl/spi1.webp 2320w',
        // ],
        sizes: ['90vw'],
        priority: true,
      }
    },
    {
      img: {
        src: 'assets/img/pram2.jpg',
        // width: 1120,
        // height: 742,
        alt: 'Warten auf den Start bei einer Regatta im YSTM',
        //style: 'width:100%;height:100%;object-fit:cover;object-position:50% 40%;',
        objectPosition: '50% 40%',
        // srcset: [
        //   'assets/img/xs/pram2.webp 688w',
        //   'assets/img/sm/pram2.webp 912w',
        //   'assets/img/md/pram2.webp 1120w',
        //   'assets/img/lg/pram2.webp 1360w',
        //   'assets/img/xl/pram2.webp 2320w',
        // ],
        sizes: ['90vw'],
        priority: true,
      }
    },
  ];

  // public tiles: YsCarouselTile[] = [
  //   {styleClass: 'carAnsprechpartner1'},
  //   {styleClass: 'carAnsprechpartner2'},
  //   {styleClass: 'carAnsprechpartner3'},
  // ]

}
